import React, { useContext, useEffect, useState } from 'react';
import Styled from './AdminModal.styled';
import { Modal } from 'react-bootstrap';
import Row from 'components/Row';
import PerfilUsuario from 'models/perfil/PerfilUsuario';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Select, { SelectOptionType } from 'components/Select';
import { Input } from 'antd';
import { EstadosEnum } from 'enums/EstadosEnum';
import { ProfileService } from 'core/http/service/Profile.service';
import LocalidadeDTO from 'models/perfil/LocalidadeDTO';
import { AccessPermissionContext } from 'core/context/AccessPermissionContext';
import EstadoDTO from 'models/perfil/EstadoDTO';

export interface IFormModalInfoEdit {
    estado: EstadosEnum;
    cidade: string;
    cpf: string;
    email: string;
}

interface ICitys {
    label: string;
    value: string;
}

interface IAdminModalInfoEdit {
    show: boolean;
    onHide: () => void;
    perfil: PerfilUsuario;
    onSubmit: (perfil: PerfilUsuario, dados: IFormModalInfoEdit) => Promise<void>;
}

const profileService = new ProfileService();

const AdminModalInfoEdit = ({ show, onHide, perfil, onSubmit }: IAdminModalInfoEdit) => {
    const { parametrosPerfil } = useContext(AccessPermissionContext.Context);

    const [form, setForm] = useState<IFormModalInfoEdit>({
        cidade: perfil.cidade || '',
        estado: (perfil.estado as EstadosEnum) || EstadosEnum.AC,
        cpf: perfil.cpf || '',
        email: perfil.email || '',
    });
    const [isLoadingCities, setIsLoadingCities] = useState(false);
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [cidades, setListCidades] = useState<ICitys[]>([]);
    const [estados, setListEstados] = useState<EstadoDTO[]>([]);

    const loadCidadesPorUf = async (uf: string) => {
        try {
            setIsLoadingCities(true);
            const response: any = await profileService.consultarCidadesPorUF(uf);
            const _cidades: LocalidadeDTO[] = response.data.map((item: any) => new LocalidadeDTO().fromJSON(item));
            const _cidadesDto = new Array();

            for (const cidade of _cidades) {
                _cidadesDto.push({ label: cidade.nome, value: cidade.nome });
            }

            setListCidades(_cidadesDto);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoadingCities(false);
        }
    };

    useEffect(() => {
        if (perfil.estado) {
            loadCidadesPorUf(perfil.estado);
        }

        if (parametrosPerfil) {
            setListEstados(parametrosPerfil.listaEstados);
        }

        setForm({
            cidade: perfil.cidade || '',
            estado: perfil.estado as EstadosEnum,
            cpf: perfil.cpf || '',
            email: perfil.email || '',
        });
    }, [perfil, parametrosPerfil]);

    const hide = () => {
        setSubmitting(false);
        onHide();
    };

    return (
        <Modal show={show} onHide={hide}>
            <Styled.Container>
                <Row justify="space-between">
                    <Styled.Title>Alterar Dados</Styled.Title>
                    <Styled.CloseIconContainer>
                        <AiOutlineCloseCircle onClick={() => onHide()} />
                    </Styled.CloseIconContainer>
                </Row>
                <br />
                <Styled.Text>Usuário: {perfil.apelido}</Styled.Text>
                <Styled.TextStrong>CPF:</Styled.TextStrong>
                <Input
                    size="large"
                    value={form.cpf}
                    onChange={e => setForm(prev => ({ ...prev, cpf: e.target.value }))}
                    placeholder="Digite o CPF do usuário"
                />
                <Styled.TextStrong>E-mail:</Styled.TextStrong>
                <Input
                    size="large"
                    type="email"
                    value={form.email}
                    onChange={e => setForm(prev => ({ ...prev, email: e.target.value }))}
                    placeholder="Digite o e-mail do usuário"
                />
                <Styled.TextStrong>Estado:</Styled.TextStrong>
                <Select
                    isSmall
                    value={{ value: form.estado as EstadosEnum, label: form.estado }}
                    itens={estados.map(estado => ({ label: estado.nome, value: estado.id }))}
                    width="100%"
                    onSelected={o => {
                        setForm((prev: IFormModalInfoEdit) => ({ ...prev, estado: o.value as EstadosEnum, cidade: 'Selecione' }));
                        loadCidadesPorUf(o.value.toString());
                    }}
                />
                <Styled.TextStrong>Cidade:</Styled.TextStrong>
                <Select
                    isSmall
                    disabled={isLoadingCities}
                    value={{ value: form.cidade || '', label: form.cidade }}
                    itens={[{ value: 'Selecione', label: 'Selecione' }, ...cidades.map(city => ({ label: city.label, value: city.value }))]}
                    width="100%"
                    onSelected={o => setForm((prev: IFormModalInfoEdit) => ({ ...prev, cidade: o.value.toString() }))}
                />
                <br />
                <br />
                <Row justify="space-between">
                    <Styled.CancelButton onClick={hide}>Cancelar</Styled.CancelButton>
                    <Styled.PrimaryButton
                        onClick={async () => {
                            setSubmitting(true);
                            try {
                                await onSubmit(perfil, form);
                            } finally {
                                setSubmitting(false);
                            }
                        }}
                        disabled={submitting}
                    >
                        {submitting ? 'Alterando' : 'Alterar Dados'}
                    </Styled.PrimaryButton>
                </Row>
            </Styled.Container>
        </Modal>
    );
};

export default AdminModalInfoEdit;
